import React, { FC } from "react";
import { Location } from "history";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { ReactComponent as AdminSVG } from "go-core/images/svg/navigation/admin-circle.svg";
import { ReactComponent as FileSVG } from "go-core/images/svg/navigation/file.svg";
import { ReactComponent as DashboardSVG } from "go-core/images/svg/navigation/home.svg";
import { ReactComponent as ReportSVG } from "go-core/images/svg/navigation/reports.svg";
import { selectUser } from "go-security/services/users/selectors";
import { UserState } from "go-security/services/users/types";

interface NavigationProps {
	user: UserState;
	isAdmin?: boolean;
	goaccounts_url: string;
}

const NavigationUserMenu: FC<NavigationProps> = (props) => {
	const { t } = useTranslation();
	const isAdmin = props.isAdmin !== undefined ? props.isAdmin : false;
	const user = useSelector(selectUser);
	const isSupportRole = user?.roles?.includes("ROLE_SUPPORT") || isAdmin;

	return (
		<Nav variant="pills" className="flex-column">
			<Nav.Item>
				<Nav.Link
					as={NavLink}
					to="/dashboard"
					isActive={(_, location: Location) => {
						return location.pathname === "/" || location.pathname === "/dashboard";
					}}
				>
					<div className="nav-link-svg">
						<DashboardSVG />
					</div>
					<span>{t("components.navigation.dashboard.title")}</span>
				</Nav.Link>
			</Nav.Item>
			<Nav.Item>
				<Nav.Link as={NavLink} to="/reports">
					<div className="nav-link-svg">
						<ReportSVG />
					</div>
					<span>{t("components.navigation.reports.title")}</span>
				</Nav.Link>
			</Nav.Item>
			{isAdmin && (
				<>
					<div className="divider" />
					<Nav.Link as={NavLink} to="/admin/tenants">
						<div className="nav-link-svg">
							<FileSVG />
						</div>
						<span>{t("lib:go_security.tenant.header.title")}</span>
					</Nav.Link>
					<Nav.Item>
						<Nav.Link as={NavLink} to={`/admin/client_details`}>
							<div className="nav-link-svg">
								<FileSVG />
							</div>
							<span>{t("go_component.client_details.header.title", { ns: "lib" })}</span>
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link href={`${props.goaccounts_url}/admin`}>
							<div className="nav-link-svg">
								<AdminSVG />
							</div>
							<span>{t("components.navigation.admin.title")}</span>
						</Nav.Link>
					</Nav.Item>
				</>
			)}
			{isSupportRole && (
				<>
					<Nav.Item>
						<Nav.Link as={NavLink} to="/jobs">
							<div className="nav-link-svg">
								<FileSVG />
							</div>
							<span>{t("go_component.job.header.title", { ns: "lib" })}</span>
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={NavLink} to={`/admin/product_packages`}>
							<div className="nav-link-svg">
								<FileSVG />
							</div>
							<span>{t("modules.product_package.header.title")}</span>
						</Nav.Link>
					</Nav.Item>
				</>
			)}
		</Nav>
	);
};

export default NavigationUserMenu;
